import { useState } from "react";
import Issues from "./Issues";

export default function IssueLayout() {
  /*   All States
   ********************************************* */

  /*   All Functions
   ********************************************* */

  /*   All UseEffects
   ********************************************* */
  return (
    <div>
      <div className=" ms-2">
        <div>
          <Issues />
        </div>
      </div>
    </div>
  );
}
